import React from 'react';
import type { StoreType } from '../api/types';
import './su-components.css';

const className = (type: StoreType) => (type === 'NEW_STORE' ? 'NEW' : type);

/** Small coloured badge (store detail page). Lists use <StoreName> instead. */
const StoreTypeTag: React.FC<{ type: StoreType }> = ({ type }) => (
  <span className={`su-tag ${className(type)}`}>{className(type)}</span>
);

/** Store name with a translucent highlight by type (LTL cyan, PTL pink, New white), so no separate tag is needed. */
export const StoreName: React.FC<{ name: string; type: StoreType }> = ({ name, type }) => (
  <span className={`su-sname ${className(type)}`}>{name}</span>
);

/** Legend for the three highlight colours; shown above each store list. */
export const StoreTypeLegend: React.FC = () => (
  <div className="su-legend" aria-label="Store type colours">
    <span className="su-sname LTL">LTL</span>
    <span className="su-sname PTL">PTL</span>
    <span className="su-sname NEW">New</span>
  </div>
);

export default StoreTypeTag;
